import { z } from 'zod';

export const conversationListResourcesQuery = z.object({
  hub_id: z.string().uuid(),
  agent_id: z.string().uuid().optional(),
});

export const conversationReadResourceQuery = z.object({
  hub_id: z.string().uuid(),
});

export type ConversationListResourcesResponse = {
  ok: true;
  data: Array<{
    file_id: string;
    file_name: string;
    mime_type: string;
    file_size: number | null;
  }>;
} | { ok: false; error: string };

export type ConversationReadResourceResponse = {
  ok: true;
  data: {
    file_id: string;
    file_name: string;
    content: string;
    mime_type: string;
  };
} | { ok: false; error: string };
